import type { MithrilVNode } from '../../mithril';
import { MaterialIcon } from '../icon/icons';
import { addStyles, DefaultTheme } from '../theme';
import { ColorPalette2022Branding } from '../theme.palette';
import { ImageButton, type ImageButtonCtx } from './image.button';

export const CSS = {
	container: 'c-DrawButton',
	isSelected: 'c-DrawButton--selected',
	solidBackground: 'c-DrawButton--solidBackground',
	isSelectedInsight: 'c-DrawButton--selected-insight',
};

addStyles({
	[CSS.container]: {
		'margin-bottom': DefaultTheme.space(2),
		color: DefaultTheme.font.color.primary,
		'background-color': DefaultTheme.background.offWhite + '99',
		'box-shadow': DefaultTheme.shadow.box.dp6,
		'&.mdl-button[disabled]': {
			'background-color': DefaultTheme.background.offWhite + '99',
		},
		'&:hover': {
			'background-color': ColorPalette2022Branding.darkGray + '99',
			color: DefaultTheme.font.color.white,
		},
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		'&:focus:not(:active)': {
			border: `2px solid ${DefaultTheme.background.darkGrey}`,
			'background-color': ColorPalette2022Branding.darkGray + '99',
			color: DefaultTheme.font.color.white,
		},
	},
	[CSS.solidBackground]: {
		'&:hover': {
			'background-color': DefaultTheme.background.fadedGrey,
		},
		'&:focus:not(:active)': {
			'background-color': DefaultTheme.background.fadedGrey,
		},
	},
	[CSS.isSelected]: {
		'background-color': DefaultTheme.color.accent,
		'&:focus:not(:active)': {
			'background-color': DefaultTheme.color.accent,
		},
		'&:focus:not(:hover)': {
			'background-color': DefaultTheme.color.accent,
		},
	},
	[CSS.isSelectedInsight]: {
		color: DefaultTheme.font.color.white,
		'background-color': DefaultTheme.color.lightIndigo,
		'&:focus:not(:active)': {
			'background-color': DefaultTheme.color.lightIndigo,
		},
		'&:focus:not(:hover)': {
			'background-color': DefaultTheme.color.lightIndigo,
		},
	},
});

export interface DrawButtonCtx extends ImageButtonCtx {
	selected?: boolean;
	solidBackground?: boolean;
	hidden?: boolean;
	isSelectedInsight?: boolean;
}

export const DrawButton = {
	view(icon: MaterialIcon | MithrilVNode, ctx: DrawButtonCtx = {}): MithrilVNode {
		if (ctx.className != null) {
			ctx.className = `${ctx.className} ${CSS.container}`;
		} else {
			ctx.className = CSS.container;
		}

		if (ctx.solidBackground) {
			ctx.className += ` ${CSS.solidBackground}`;
		}

		if (ctx.selected) {
			ctx.className = `${ctx.className} ${CSS.isSelected}`;
		}

		if (ctx.hidden) {
			ctx.className = `${ctx.className} hidden`;
		}

		if (ctx.isSelectedInsight) {
			ctx.className = `${ctx.className} ${CSS.isSelectedInsight}`;
		}

		ctx.type = 'button';
		return ImageButton.view(icon, ctx);
	},
};
